import { render, staticRenderFns } from "./TaskApplicationApp.vue?vue&type=template&id=9abb0684&scoped=true&lang=pug&"
import script from "./TaskApplicationApp.vue?vue&type=script&lang=js&"
export * from "./TaskApplicationApp.vue?vue&type=script&lang=js&"
import style0 from "./TaskApplicationApp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TaskApplicationApp.vue?vue&type=style&index=1&id=9abb0684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abb0684",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
